module.exports = "<app-route-edit-general route=$ctrl.route on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)> </app-route-edit-general> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/general/template.html
// module id = 474
// module chunks = 0